BookingsEditQualificationsController.$inject = [
    '_',
    '$uibModalInstance',
    'deps',
];

/* @ngInject */
function BookingsEditQualificationsController(_, $uibModalInstance, deps) {
    var vm = this;
    vm.title = 'BookingsEditQualificationsController';

    var qualifications = deps.qualifications || {};
    vm.qualifications = {
        punctuality: qualifications.hasOwnProperty('punctuality')
            ? qualifications.punctuality
            : null,
        facilities: qualifications.hasOwnProperty('facilities')
            ? qualifications.facilities
            : null,
        payment: qualifications.hasOwnProperty('payment')
            ? qualifications.payment
            : null,
    };

    vm.select = function (type, value) {
        vm.qualifications[type] = value;
    };

    vm.isValid = function () {
        return _.isUndefined(
            _.find(vm.qualifications, function (value, key) {
                return _.isNull(value);
            }),
        );
    };

    vm.accept = function () {
        $uibModalInstance.close(vm.qualifications);
    };

    vm.close = function () {
        $uibModalInstance.dismiss(null);
    };
}

export default BookingsEditQualificationsController;
